<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-table titlePage="DETALHES DO FATURAMENTO" :data="tableData" :dadosRel="dadosRel" :columnsPDF="columnsPDF" :headRowsPDF="headRowsPDF" :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" :bodyRowsPDF="bodyRowsPDF" colSpanPDF="7" :totalPDF="total" :totalHide="true" :btnHide="true" titleReport="Relatório de Pagamentos">
                <md-button v-if="permissoes.faturamentoRead" class="md-button md-site md-just-icon md-round" :to="{ name: 'faturamentoRead' }">
                    <md-icon>assignment</md-icon>
                    <md-tooltip md-direction="top">Faturamento</md-tooltip>
                </md-button>
            </header-table>
            <md-card-content>
                <div class="md-layout">
                    <div class="md-layout-item md-size-20 md-xsmall-size-100">
                        <md-field>
                            <label for="pages">Listar</label>
                            <md-select v-model="pagination.perPage" name="pages">
                                <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                    {{ item }}
                                </md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div v-if="permissoes.faturamentoEmpresaCreate" class="md-layout-item md-size-20 md-xsmall-size-100 ml-auto">
                        <md-button @click="faturar" class="md-success md-block md-round text-right md-sm">
                            <i class="fs-12 fas fa-coins mr-5"></i> <span class="fs-12"> FATURAR</span>
                        </md-button>
                    </div>
                </div>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">
                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                        <md-table-cell class="uppercase" md-label="CLIENTE" style="width: 30%">{{ item.cliente }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="CPF" style="width: 15%">{{ item.cpf_cnpj }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="CONTRATO" style="width: 10%">{{ item.contrato }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="FORNECEDOR" style="width: 25%">{{ item.fornecedor }}</md-table-cell>
                        <md-table-cell v-if="item.id" md-label="PARCELA" style="width: 10%">{{ item.parcela }}</md-table-cell>
                        <md-table-cell v-if="!item.id" md-label="PARCELA" style="width: 10%"><strong>{{ item.parcela }}</strong></md-table-cell>
                        <md-table-cell v-if="item.id" md-label="VALOR" style="width: 10%">{{ item.valor }}</md-table-cell>
                        <md-table-cell v-if="!item.id" md-label="VALOR" style="width: 10%"><strong>{{ item.valor }}</strong></md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to" :total="total">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
            </footer-table>
        </md-card>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify'
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';
import Swal from "sweetalert2";

export default {
    name: 'PlanoRead',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    data() {
        return {
            dados: {
                id: this.$route.params.id,
                dia: this.$route.query.dia,
                periodo: this.$route.query.periodo
            },
            permissoes: this.$store.state.usuario.permissao,
            columnsPDF: [40, 27, 22, 35, 35, 20],
            headRowsPDF: ['FUNCIONÁRIO', 'CPF', 'CONTRATO', 'EMPRESA', 'FORNECEDOR', 'VALOR'],
            bodyRowsPDF: ['cliente', 'cpf_cnpj', 'contrato', 'empresa', 'fornecedor', 'valor'],
            fildsTXT: ['cliente', 'cpf_cnpj', 'empresa', 'fornecedor', 'contrato', 'unidade', 'parcela', 'data_pagamento', 'valor_bd'],
            columnsExcel: [

                {
                    label: "FUNCIONÁRIO",
                    field: "cliente",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "CPF",
                    field: "cpf_cnpj"
                },
                {
                    label: "CONTRATO",
                    field: "contrato"
                },
                {
                    label: "UNIDADE",
                    field: "unidade"
                },
                {
                    label: "EMPRESA",
                    field: "empresa",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "FORNECEDOR",
                    field: "fornecedor",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "PARCELA",
                    field: "parcela"
                },
                {
                    label: "VALOR",
                    field: "valor_decimal"
                },
                {
                    label: "DATA",
                    field: "data_pagamento"
                }
            ],
            search: null,
            tableData: [],
            searchedData: [],
            dadosRel: [],
            buscar: {
                busca: '',
                dataInicial: null,
                dataFinal: null
            }
        };
    },

    mixins: [TableSearch, Notify, preLoader],

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read() {
            let loader = this.openLoader('dots');
            this.$http.post(this.$urlAPI + 'financeiro/faturamento-visualizar', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.tableData = response.data.dados
                        this.dadosRel = response.data.lista
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower(
                    [item.cliente, item.cpf_cnpj, item.fornecedor, item.empresa, item.data_pagamento, item.valor, item.pesquisa]
                ).includes(this.toLower(term)))
            }
            return items
        },

        faturar() {
            this.$http.post(this.$urlAPI + 'financeiro/faturamento-faturar', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.success(response.data.message)
                        this.$router.push({
                            name: 'faturamentoRead'
                        })
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },
    },

};
</script>
